import { useMemo, useState } from "react";
import { Button, Stack } from "@mui/material";
import { TagButton, TagButtonProps } from "./TagButton";
import { removeMondooLink } from "~/lib/findingUtils";
import { IGNORE_LABELS } from "../../../../../../constants";
import { useColorMode } from "~/providers/color-mode";

type TagButtonRowProps = {
  items: TagButtonProps["item"][];
};

export function TagButtonRow({ items }: TagButtonRowProps) {
  const { mode } = useColorMode();
  const [showMore, setShowMore] = useState(false);

  const shouldShowButton = items.length > 4;

  const shownItems = useMemo(() => {
    return items
      .filter((tag) => !IGNORE_LABELS.includes(tag.key))
      .slice(0, showMore ? items.length : 4)
      .map((item) => ({
        ...item,
        key: removeMondooLink(item.key),
      }));
  }, [items, showMore]);

  const handleShowClick = () => {
    setShowMore((prev) => !prev);
  };

  if (!shownItems?.length) {
    return;
  }

  return (
    <>
      <Stack direction="row" gap={1} flexWrap="wrap" sx={{ my: 1 }}>
        {shownItems.map((label) => {
          return <TagButton item={label} key={label.key} />;
        })}
      </Stack>

      <Button
        className="show-more-toggle"
        variant="text"
        onClick={handleShowClick}
        sx={{
          display: shouldShowButton ? "block" : "none",
          px: 0,
          background: "transparent",
          textTransform: "none",
          fontWeight: 600,
          color: mode === "light" ? "secondary.main" : "secondary.light",
          "&:hover": { background: "transparent" },
        }}
      >
        Show {showMore ? "less" : "more"}
      </Button>
    </>
  );
}
